import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: t('home'), id: 'home' },
    { label: t('services'), id: 'services' },
    { label: t('solutions'), id: 'solutions' },
    { label: t('about'), id: 'about' },
    { label: t('contact'), id: 'contact' }
  ];

  const services = [
    t('services.electrical.title'),
    t('services.networking.title'),
    t('services.hvac.title'),
    t('services.digitalsignage.title'),
    t('services.audiovisual.title'),
    t('services.construction.title')
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', color: 'hover:text-blue-600' },
    { icon: 'ri-twitter-fill', href: '#', color: 'hover:text-sky-500' },
    { icon: 'ri-linkedin-fill', href: '#', color: 'hover:text-blue-700' },
    { icon: 'ri-instagram-fill', href: '#', color: 'hover:text-pink-600' },
    { icon: 'ri-whatsapp-fill', href: 'https://wa.me/966556421472', color: 'hover:text-green-600' }
  ];

  return (
    <footer className="bg-[#005776] text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <img 
                src="https://static.readdy.ai/image/e20f1140862a90922d0fa0db5fb08a3f/29937fdb360de9482c6529403137c934.png" 
                alt="RAM LIMITED" 
                className="h-12 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/80 mb-6 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className={`w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-white transition-colors cursor-pointer ${social.color}`}
                  target={social.href.startsWith('http') ? '_blank' : '_self'}
                  rel={social.href.startsWith('http') ? 'noopener noreferrer' : ''}
                >
                  <i className={social.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t('footer.services.title')}</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-white/80 hover:text-white transition-colors cursor-pointer">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t('footer.contact.title')}</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-[#FE5000] mt-1 mr-3"></i>
                <p className="text-white/80 text-sm leading-relaxed">
                  {t('footer.contact.address')}
                </p>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-[#FE5000] mr-3"></i>
                <a href="tel:+966556421472" className="text-white/80 hover:text-white transition-colors">
                  +966 55 642 1472
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[#FE5000] mr-3"></i>
                <a href="mailto:contact@almukhatat.sa" className="text-white/80 hover:text-white transition-colors">
                  contact@almukhatat.sa
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 text-center">
          <p className="text-white/60">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}
